import { useEffect } from 'react';

import Smartlook from 'smartlook-client';

import { appConfig } from '@ll-platform/frontend/config/app.config';
import { analyticsDebugLog } from '@ll-platform/frontend/core/analytics/activityTracker';
import type { ActiveUserProfile } from '@ll-platform/frontend/core/auth/types';
import { useOptionalActiveOrganization } from '@ll-platform/frontend/core/organization/ActiveOrganizationProvider';

export const useSmartlook = (activeUser?: ActiveUserProfile) => {
  const { activeOrganization } = useOptionalActiveOrganization();

  useEffect(() => {
    const key = appConfig.REACT_APP_SMARTLOOK_KEY;
    if (!key) {
      return;
    }
    analyticsDebugLog(`Initializing Smartlook`);
    Smartlook.init(key);
  }, []);

  useEffect(() => {
    if (!Smartlook.initialized()) {
      return;
    }

    if (activeUser) {
      const { _id, email, accountType, isActive } = activeUser;
      analyticsDebugLog(`Identifying user ${_id} ${email} in Smartlook`);
      if (activeOrganization) {
        analyticsDebugLog(
          `Identifying organization ${activeOrganization.id} ${activeOrganization.name} in Smartlook`,
        );
      }
      Smartlook.identify(_id, {
        email,
        accountType,
        isActive,
        ...(activeOrganization && {
          organizationId: activeOrganization.id,
          organizationName: activeOrganization.name,
          organizationDomain: activeOrganization.domain ?? '',
        }),
      });
    } else {
      analyticsDebugLog(`Deidentifying user in Smartlook`);
      Smartlook.anonymize();
    }
  }, [activeUser, activeOrganization]);
};
